/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const newsletterSubscriber_register = createAsyncThunk(
    'home/newsletterSubscriber_register',
    async(info, { rejectWithValue, fulfillWithValue }) => {
        try {
            //console.log(info)
            const {data} = await api.post('/home/newsletterSubscribe-register', info)
            return fulfillWithValue(data)
        } catch (error) {
            //console.log(error.respone)
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const newsletterSubscriberReducer = createSlice({
    name: 'newsletterSubscriber',
    initialState:{
        successMessage :  '', 
        errorMessage : '' 
        //newsletterSubscriber: '' 
    },
    reducers : {
        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers : (builder) => {
        builder
        .addCase(newsletterSubscriber_register.fulfilled, (state, { payload }) => {
            //state.newsletterSubscriber = payload.newsletterSubscriber
            state.successMessage = payload.message
        //     state.sellerPackages = payload.sellerPackages;
        //     //console.log(state.sellerPackages) //works
        //     //console.log('get_sellerPackages_webSiteOrigin ', payload.sellerPackages, payload.totalSellerPackage)
        })
        .addCase(newsletterSubscriber_register.rejected, (state, { payload }) => {
            state.errorMessage = payload.error;
        })    
      
    }})

    export const {messageClear} = newsletterSubscriberReducer.actions
    export default newsletterSubscriberReducer.reducer
